import { useState, useEffect } from "react";
import _ from "lodash";
import { useMobileDetectContext } from "../context/MobileDetectContext";

const useScrollBehavior = () => {
  const [scrollY, setScrollY] = useState(0);
  const [lastScrollY, setLastScrollY] = useState(0);
  const [scrollDirection, setScrollDirection] = useState("up");
  const [isScrolling, setIsScrolling] = useState(false);
  const [isTouching, setIsTouching] = useState(false);
  const [isNearFooter, setIsNearFooter] = useState(false);

  const { isMobileOnly } = useMobileDetectContext();
  const scrollThreshold = 5; // Threshold of 5px for showing the header again on scroll up

  const handleScroll = _.debounce(() => {
    const currentScrollY = window.scrollY;
    const scrollableHeight =
      document.documentElement.scrollHeight - window.innerHeight;

    // Detect if near the footer
    setIsNearFooter(scrollableHeight - currentScrollY < 100);

    // Set scroll direction with threshold
    if (currentScrollY > lastScrollY + scrollThreshold && currentScrollY > 1) {
      setScrollDirection("down");
    } else if (currentScrollY < lastScrollY - scrollThreshold) {
      setScrollDirection("up");
    }

    setScrollY(currentScrollY);
    setLastScrollY(currentScrollY);
    setIsScrolling(true);

    // Reset scrolling state after a delay
    setTimeout(() => setIsScrolling(false), 150);
  }, 10);

  // Touch handlers (optional, for revealing on touch)
  // const handleTouchStart = () => {
  //   setIsTouching(true);
  // };

  // const handleTouchEnd = () => {
  //   setIsTouching(false);
  // };

  useEffect(() => {
    if (!isMobileOnly) return; // Prevent the hook from running on non-mobile devices

    window.addEventListener("scroll", handleScroll);
    // window.addEventListener("touchstart", handleTouchStart);
    // window.addEventListener("touchend", handleTouchEnd);

    return () => {
      window.removeEventListener("scroll", handleScroll);
      // window.removeEventListener("touchstart", handleTouchStart);
      // window.removeEventListener("touchend", handleTouchEnd);
    };
  }, [lastScrollY, isMobileOnly]); // Re-run if lastScrollY or isMobileOnly changes

  return { scrollY, scrollDirection, isScrolling, isTouching, isNearFooter };
};

export default useScrollBehavior;
